import { useMemo } from 'react';

const SPECIAL_CHARS = '!"@#$%&\'()*+,-./:;<=>?[]^_{|}~';

export default function usePasswordRules(password: string = '') {
  const isCaracterNumberValid = useMemo(() => password?.length >= 12, [password]);
  const isPasswordContainsLowercase = useMemo(() => /[a-z]/.test(password), [password]);
  const isPasswordContainsUppercase = useMemo(() => /[A-Z]/.test(password), [password]);
  const isPasswordContainsNumber = useMemo(() => /[0-9]/.test(password), [password]);
  const isPasswordContainsSpecialChar = useMemo(() => {
    return password?.split('')?.some((newPasswordWatch) => SPECIAL_CHARS.includes(newPasswordWatch));
  }, [password]);

  const isPasswordValid = useMemo(
    () =>
      isCaracterNumberValid &&
      isPasswordContainsLowercase &&
      isPasswordContainsUppercase &&
      isPasswordContainsNumber &&
      isPasswordContainsSpecialChar,
    [
      isCaracterNumberValid,
      isPasswordContainsLowercase,
      isPasswordContainsNumber,
      isPasswordContainsSpecialChar,
      isPasswordContainsUppercase,
    ],
  );

  return {
    isCaracterNumberValid,
    isPasswordContainsLowercase,
    isPasswordContainsUppercase,
    isPasswordContainsNumber,
    isPasswordContainsSpecialChar,
    isPasswordValid,
  };
}
